var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9C10.3866 12.9 10.7 13.2134 10.7 13.6L10.7 14C10.7 14.3866 10.3866 14.7 10 14.7C9.6134 14.7 9.3 14.3866 9.3 14L9.3 13.6C9.3 13.2134 9.6134 12.9 10 12.9Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0522 5.30078L9.94793 5.30078L9.93949 5.30098C8.59881 5.33331 7.52227 6.42985 7.52227 7.77803C7.52227 8.16463 7.83567 8.47803 8.22227 8.47803C8.60887 8.47803 8.92227 8.16463 8.92227 7.77803C8.92227 7.19422 9.3866 6.71867 9.96584 6.70078L10.0343 6.70078C10.6257 6.71897 11.1005 7.20557 11.1005 7.77803C11.1005 7.9573 11.0385 8.14875 10.9218 8.33734L10.8941 8.38064C10.7831 8.55011 10.6459 8.72556 10.4849 8.92551L10.4112 9.01675C10.2741 9.18635 10.1228 9.37356 9.98431 9.56372C9.66179 10.0067 9.31475 10.5868 9.3005 11.2889C9.29266 11.6755 9.59963 11.9951 9.98615 12.003C10.3727 12.0108 10.6924 11.7039 10.7002 11.3173C10.7054 11.0605 10.8349 10.774 11.1161 10.3878C11.2319 10.2288 11.3574 10.0734 11.4948 9.90329L11.5753 9.80359C11.7377 9.60188 11.9149 9.37793 12.0679 9.14366L12.1036 9.08796L12.1081 9.08069C12.3277 8.72805 12.5005 8.28178 12.5005 7.77803C12.5005 6.4184 11.3904 5.33303 10.0606 5.30098L10.0522 5.30078Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 16.6C13.6451 16.6 16.6 13.6451 16.6 10C16.6 6.35492 13.6451 3.4 10 3.4C6.35492 3.4 3.4 6.35492 3.4 10C3.4 13.6451 6.35492 16.6 10 16.6Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.fdf500b70799fea7e16cfd87f0a61e22.svg";
export { ForwardRef as ReactComponent };